<template>
  <div class="property_wrap">

      <div class="pro_top">图片设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form label-width="80px">
          <el-form-item label="标题:">
            <el-input v-model="property.title"></el-input>
          </el-form-item>
        </el-form>
        <el-form label-width="80px">
          <el-form-item label="链接地址:">
            <el-input v-model="property.url"></el-input>
            <p class="infodescribe">现仅支持https://720yun.com/提供的服务</p>
          </el-form-item>
        </el-form>
        <el-form-item label="封面图:">
          <el-upload
                  class="avatar-uploader"
                  :action="actionUrl"
                  :data="data_"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-progress="progressFn">
            <img v-if="form.pic" :src="form.pic" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="infodescribe">(图片大小不超过10M，1M以内不压缩，1M以上将压缩至20%大小，支持jpg、png格式)</p>
        </el-form-item>
      </el-form>
      <el-form label-width="80px">
        <el-form-item label="首页展示:">
          <el-switch
                  @change="switchChange($event)"
                  v-model="is_tatus"
                  active-color="#2AA3F8"
                  inactive-color="#ddd">
          </el-switch>
          <p class="infodescribe">开启后会在名片首页展示，不影响官网VR展示</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    props: ["property"],
    data() {
      return {
        actionUrl: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        is_tatus: false,
        form: {
          label: '',
          title: '',
          pic: '',
          url: '',
          status: ''
        }
      };
    },
    watch: {
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    mounted() {
      this.$emit('update:property', this.form)
    },
    methods: {
      switchChange(event){
        this.form.status = 0
        if(event){
          this.form.status = 1
        }
      },
      handleAvatarSuccess(res, file) {
        if (res.code === 0) {
          this.form.pic = res.path
          this.$message({
            message: '上传成功',
          });
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 10MB!');
        }
        return isLt2M;
      }
    }
  };
</script>

